import React, { Component } from "react";
import NavTab from '../../../components/common/global_layout/navTab2'

import CustomCard from '../../../components/common/customCard'

import { Container ,Row} from "reactstrap";
import {connect } from 'react-redux';
import Footer from '../../../components/common/global_layout/footer'

class Cars extends Component {
    render() { 
        return (
          <>
            <NavTab />
            <Container className="custmCars">
              <div className="custom-card cards-Vol">
                <Row>
                  <CustomCard
                    height={250}
                    size={6}
                    imgPath={"/imgs/cars/vehiculeRenting/Clip.png"}
                    linkPath={"/cars/location"}
                    title={"Louer un Véhicule"}
                    subtitle={"70000 DZD"}
                  />
                  <CustomCard
                    height={250}
                    size={6}
                    imgPath={"/imgs/cars/aeroportTransfer/Clip.png"}
                    linkPath={"/cars/transfert"}
                    title={"Transfert Aéroport"}
                    subtitle={"70000 DZD"}
                  />
                </Row>
              </div>
            </Container>
            {/* <Footer /> */}
          </>
        );
    }
}

//connects component with redux store state
const mapStateToProps = state => ({
  /*
  count: state.counterApp.counter,
  date: state.counterApp.date
  */
})

//connect function INJECTS dispatch function as a prop!!
export default connect(mapStateToProps)(Cars);
 
